<p>
  Hier sind alle Termine, die in der Feuerwehr stattfinden sichtbar (auch Termine, bei welchen du nicht teilnehmen musst als Übersicht). Diese Liste kann auch durchsucht werden, sowie nach Gruppen gefiltert. Nach dem Aufrufen eines Termins kannst du (insofern du die Gruppenberechtigung hast) zu diesem Termin zu-/absagen. Bei einer Absage wird
  dieser auch aus deinem personalisierten Kalender entfernt.
</p>
<br />
<p>
  Ab drei Stunden vor Terminbeginn kann, (insofern du die Gruppenberechtigung hast oder Ausbilder bei dem Termin bist) die Anwesenheit gepflegt werden. Diese kann von den positiven Rückmeldungen übernommen werden. Personen können einzeln hinzugefügt und mittels des X neben dem Namen entfernt werden. Am Ende des Termins muss dieser mit der
  Enduhrzeit und Beschreibung abgeschlossen werden.
</p>
